import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.base`;
export const INIT = `${SCOPE}/INIT`; // sets initial state

// setup interval and other parameters
export const UPDATE = `${SCOPE}/UPDATE`;

export const SET_SELECTED_METRIC = `${SCOPE}/SET_SELECTED_METRIC`;

export const SET_SELECTED_DIMENSION = `${SCOPE}/SET_SELECTED_DIMENSION`;
export const SWAP_SELECTED_DIMENSION = `${SCOPE}/SWAP_SELECTED_DIMENSION`;
export const SET_DIMENSION_UNIT = `${SCOPE}/SET_DIMENSION_UNIT`;

export const SET_SELECTED_KPI = `${SCOPE}/SETSELECTED_KPI`;
export const DIMENSION_DRILLDOWN = `${SCOPE}/DIMENSION_DRILLDOWN`;
export const APPLY_FILTER = `${SCOPE}/APPLY_FILTER`;

export const SET_INTERVAL = `${SCOPE}/SET_INTERVAL`;

export const PUSH_BREADCRUMB = `${SCOPE}/PUSH_BREADCRUMB`;
export const POP_BREADCRUMB = `${SCOPE}/POP_BREADCRUMB`;
export const RESET_BREADCRUMB = `${SCOPE}/RESET_BREADCRUMB`;

export const FETCH_SPI_THRESHOLD = `${SCOPE}/FETCH_SPI_THRESHOLD`;
export const SET_SPI_THRESHOLD = `${SCOPE}/SET_SPI_THRESHOLD`;

export const PERSIST_STATE = `${SCOPE}/PERSIST_STATE`;
export const UPDATE_PERSISTED_OVERVIEW_STATE = `${SCOPE}/UPDATE_PERSISTED_OVERVIEW_STATE`;
export const FETCH_SELECTED_KPI_CONFIG = `${SCOPE}/FETCH_SELECTED_KPI_CONFIG`;
export const SET_SELECTED_KPI_CONFIG = `${SCOPE}/SET_SELECTED_KPI_CONFIG`;
